import _ from 'lodash'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import PaymentChoiceTypeButton from '../atoms/PaymentChoiceTypeButton'
import SVGLoadingSpinner from '../atoms/SVGLoadingSpinner'

import config from '../../configs/config'

import trackingHelpers from '../../helpers/trackingHelpers'

const displayPaymentOptions = (props = {}, renderPaypal = false, hasSimplifiedPaymentPage = false) => {
  return (
    <FormGroup>
      <Col lg={hasSimplifiedPaymentPage ? 8 : 9} smOffset={hasSimplifiedPaymentPage ? 4 : 3} className='text-left'>
        {props.paymentClientToken !== 'dtmf' &&
          <div>
            {!hasSimplifiedPaymentPage &&
              <PaymentChoiceTypeButton
                checked={props.paymentChoice === 'card' || !props.paymentChoice}
                id='creditCardButton'
                onChange={props.onPaymentChoiceChange}
                value='card'>
                <img src={`${props.assetsUrl}shared/paymentcards_065.png`} alt='Visa logo' height='20' />
              </PaymentChoiceTypeButton>
            }
            {props.activateApplePay &&
              <PaymentChoiceTypeButton
                checked={props.paymentChoice === 'applePay'}
                disabled={props.isCallCentre}
                id='applePayButton'
                onChange={props.onPaymentChoiceChange}
                value='applePay'>
                <img src={`${props.assetsUrl}shared/apple-pay.png`} alt='Apple Pay logo' height='20' />
              </PaymentChoiceTypeButton>
            }

            {renderPaypal && (
              <PaymentChoiceTypeButton
                checked={props.paymentChoice === 'paypal'}
                disabled={props.isCallCentre}
                id='paypalButton'
                onChange={props.onPaymentChoiceChange}
                value='paypal'
                activatePaypal={props.activatePaypal}>
                <img src={`${props.assetsUrl}shared/paypal.png`} alt='PayPal logo' height='20' />
              </PaymentChoiceTypeButton>
            )}
          </div>
        }

        {props.paymentClientToken === 'dtmf' &&
          <div>
            <PaymentChoiceTypeButton
              checked={props.paymentChoice === 'dtmf' || !props.paymentChoice}
              id='dtmf'
              onChange={props.onPaymentChoiceChange}
              value='dtmf'>
              <FormattedMessage id='payment.DTMF' />
            </PaymentChoiceTypeButton>

            <PaymentChoiceTypeButton
              checked={props.paymentChoice === 'skip'}
              className='text-uppercase'
              id='skip'
              onChange={props.onPaymentChoiceChange}
              value='skip'>
              <FormattedMessage id='payment.skipPayment' />
            </PaymentChoiceTypeButton>

            {/* Once https://hxshortbreaks.atlassian.net/browse/NB-1283 is in production this check can be removed as will be showing card fields on all CX SBP payment pages */}
            {props.showCxCardFields &&
              <PaymentChoiceTypeButton
                checked={props.paymentChoice === 'card' || !props.paymentChoice}
                id='creditCardButton'
                onChange={props.onPaymentChoiceChange}
                value='card'>
                <FormattedMessage id='payment.manualCardCapture' />
              </PaymentChoiceTypeButton>
            }
          </div>
        }
      </Col>
    </FormGroup>
  )
}

class PaymentChoices extends Component {
  constructor () {
    super()
    this.hasSimplifiedPaymentPage = _.get(config, 'brandConfig.secure.hasFeatures.payment.hasSimplifiedPaymentPage', false)
    this.onCardPasswordSubmit = this.onCardPasswordSubmit.bind(this)
    this.hasSimplifiedPaymentPage = _.get(config, 'brandConfig.secure.hasFeatures.payment.hasSimplifiedPaymentPage', false)
  }

  onCardPasswordSubmit (e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      document.getElementById('adminPasswordButton').click()
    } else {
      this.props.onInputChange(e.target.id, e.target.value)
    }
  }

  shouldComponentUpdate (nextProps) {
    return !_.isEqual(nextProps, this.props)
  }

  render () {
    const renderPaypal = this.props.activatePaypal.mobile ||
      this.props.activatePaypal.tablet ||
      this.props.activatePaypal.smallComputer ||
      this.props.activatePaypal.largeComputer

    const cardFieldClasses = classNames({
      'card-fields-container': true,
      'hidden': ((this.props.paymentClientToken === 'dtmf') && !this.props.adminPasswordValid) || this.props.paymentChoice !== 'card'
    })
    const cardPasswordFieldClasses = classNames({
      'password-fields-container': true,
      'hidden': (this.props.paymentClientToken !== 'dtmf') || this.props.adminPasswordValid || this.props.paymentChoice !== 'card'
    })

    return (
      <div>
        {!this.hasSimplifiedPaymentPage && displayPaymentOptions(this.props, renderPaypal)}
        {this.hasSimplifiedPaymentPage && !this.props.isCallCentre &&
          <FormGroup>
            <Col lg='8' smOffset='4' className='text-left'>
              <PaymentChoiceTypeButton
                checked={this.props.paymentChoice === 'card' || !this.props.paymentChoice}
                id='creditCardButton'
                onChange={this.props.onPaymentChoiceChange}
                value='card'>
                <img src={`${this.props.assetsUrl}shared/paymentcards_065.png`} alt='Visa logo' height='20' />
              </PaymentChoiceTypeButton>
            </Col>
          </FormGroup>
        }
        {/* Admin Password needs to be entered before showing CX card fields */}
        {this.props.showCxCardFields &&
          <div className={cardPasswordFieldClasses}>
            <FormGroup>
              <Col sm={3}>
                <ControlLabel className='gutter-top-xs' htmlFor='cxCardPassword'>
                  <FormattedMessage id='common.password' />
                </ControlLabel>
              </Col>
              <Col xs={12} sm={9} className={this.props.errors.adminPasswordError ? 'has-error' : ''}>
                <FormControl
                  id='adminCardPassword'
                  name='admin_card_password'
                  onKeyDown={(e) => this.onCardPasswordSubmit(e)}
                  type='password' />
                {this.props.errors.adminPasswordError &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.adminPasswordError}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>
            <FormGroup>
              <Col xs={12} sm={9} smPush={3}>
                <Button
                  id='adminPasswordButton'
                  bsStyle='primary'
                  style={{ 'width': '180px' }}
                >
                  {this.props.isFetchingPassword ? (
                    <SVGLoadingSpinner
                      height='1em'
                      width='1em'
                      viewBox='0 0 50 50'
                      style={{ enableBackground: 'new 0 0 50 50' }}
                      x='0px'
                      y='0px'
                      title='Loading'
                    />
                  ) : (
                    <FormattedMessage id='payment.submitPassword' />
                  )}
                </Button>
              </Col>
            </FormGroup>
          </div>
        }

        {/* Once https://hxshortbreaks.atlassian.net/browse/NB-1283 is in production this check can be removed as will be showing card fields on all CX SBP payment pages */}
        {(this.props.paymentClientToken !== 'dtmf' || this.props.showCxCardFields) &&
          <div className={cardFieldClasses}>
            <FormGroup className={this.props.paymentCardType} validationState={this.props.errors.creditCardNumber ? 'error' : null}>
              <Col componentClass={ControlLabel} htmlFor='creditCardNumber' sm={this.hasSimplifiedPaymentPage ? 4 : 3}>
                {this.hasSimplifiedPaymentPage ? (
                  <FormattedMessage id='payment.creditDebitCardNumber' data-automated-test='cardNumberLabel' />
                ) : (
                  <FormattedMessage id='payment.cardNumber' data-automated-test='cardNumberLabel' />
                )}
              </Col>

              <Col sm={5} md={6} lg={4} className='cardField'>
                <div id='creditCardNumber' className='form-control' />
                {this.props.errors.creditCardNumber &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.creditCardNumber}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} htmlFor='cardExpiryDate' sm={this.hasSimplifiedPaymentPage ? 4 : 3} className={this.props.errors.cardExpiryDate ? 'has-error' : ''}>
                <FormattedMessage id='payment.expiryDate' data-automated-test='cardExpiryDate' />
              </Col>

              <Col sm={3} className={this.props.errors.cardExpiryDate ? 'has-error' : ''}>
                <div id='cardExpiryDate' className='form-control' />
                {this.props.errors.cardExpiryDate &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.cardExpiryDate}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} htmlFor='securityCode' sm={this.hasSimplifiedPaymentPage ? 4 : 3} className={`${this.props.errors.securityCode && 'has-error'}`}>
                <FormattedMessage id='payment.securityCode' data-automated-test='cardSecurityCode' />
              </Col>

              <Col sm={3} className={this.props.errors.securityCode ? 'has-error' : ''}>
                <div id='securityCode' className='form-control' />
                {this.props.errors.securityCode &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.securityCode}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>
          </div>
        }

        {this.hasSimplifiedPaymentPage && displayPaymentOptions(this.props, renderPaypal, this.hasSimplifiedPaymentPage)}

        {this.props.paymentClientToken === 'dtmf' &&
          <div>
            <FormGroup className={this.props.paymentChoice === 'dtmf' ? null : 'hidden'}>
              <Col sm={3}>
                <ControlLabel htmlFor='dtmfCardExpiryDate'>
                  <FormattedMessage id='payment.expiryDate' />
                </ControlLabel>
              </Col>

              <Col sm={3} className={this.props.errors.dtmfCardExpiryDate ? 'has-error' : ''}>
                <FormControl
                  {...trackingHelpers.getAttributes('expiry date', 'payment', '1')}
                  id='dtmfCardExpiryDate'
                  maxLength='7'
                  name='card_expiry_date'
                  onChange={(e) => this.props.onInputChange(e.target.id, e.target.value)}
                  placeholder='MM/YY'
                  value={this.props.dtmfCardExpiryDate} />
                {this.props.errors.dtmfCardExpiryDate &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.dtmfCardExpiryDate}
                  </HelpBlock>
                }
              </Col>

              <Col sm={2} className='gutter-top-xs'>
                <ControlLabel htmlFor='dtmfSecurityCode'>
                  <FormattedMessage id='payment.securityCode' />
                </ControlLabel>
              </Col>

              <Col sm={3} className={this.props.errors.dtmfSecurityCode ? 'has-error' : ''}>
                <FormControl
                  {...trackingHelpers.getAttributes('security code', 'payment', '1')}
                  id='dtmfSecurityCode'
                  maxLength='4'
                  name='card_security_code'
                  onChange={(e) => this.props.onInputChange(e.target.id, e.target.value)}
                  value={this.props.dtmfSecurityCode} />

                {this.props.errors.dtmfSecurityCode &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.dtmfSecurityCode}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>

            <FormGroup className={(this.props.paymentChoice === 'skip' && !this.props.removeCreditCardSurcharge) ? null : 'hidden'}>
              <Col xs={6} sm={8} smOffset={3}>
                <Checkbox
                  checked={this.props.applyCreditFees}
                  id='applyCreditFees'
                  name='apply_credit_fees'
                  onChange={(e) => this.props.onInputChange(e.target.id, e.target.checked)}>
                  <FormattedMessage id='payment.applyCreditCardFees' />
                </Checkbox>
              </Col>
            </FormGroup>

            <FormGroup className={this.props.paymentChoice === 'skip' ? null : 'hidden'}>
              <Col sm={3}>
                <ControlLabel className='gutter-top-xs' htmlFor='adminPassword'>
                  <FormattedMessage id='common.password' />
                </ControlLabel>
              </Col>

              <Col xs={6} sm={8} className={this.props.errors.adminPassword ? 'has-error' : ''}>
                <FormControl
                  id='adminPassword'
                  name='admin_password'
                  onChange={(e) => this.props.onInputChange(e.target.id, e.target.value)}
                  type='password' />
                {this.props.errors.adminPassword &&
                  <HelpBlock className='pull-right'>
                    {this.props.errors.adminPassword}
                  </HelpBlock>
                }
              </Col>
            </FormGroup>
          </div>
        }
      </div>
    )
  }
}

PaymentChoices.defaultProps = {
  isCallCentre: false,
  paymentCardType: null
}

PaymentChoices.propTypes = {
  activateApplePay: PropTypes.bool.isRequired,
  activatePaypal: PropTypes.shape({
    mobile: PropTypes.bool,
    largeComputer: PropTypes.bool,
    smallComputer: PropTypes.bool,
    tablet: PropTypes.bool
  }),
  adminPasswordValid: PropTypes.bool.isRequired,
  applyCreditFees: PropTypes.bool,
  assetsUrl: PropTypes.string.isRequired,
  dtmfCardExpiryDate: PropTypes.string,
  dtmfSecurityCode: PropTypes.string,
  errors: PropTypes.object,
  isCallCentre: PropTypes.bool.isRequired,
  isFetchingPassword: PropTypes.bool,
  onInputChange: PropTypes.func.isRequired,
  onPaymentChoiceChange: PropTypes.func.isRequired,
  paymentCardType: PropTypes.string,
  paymentChoice: PropTypes.string,
  paymentClientToken: PropTypes.string.isRequired,
  removeCreditCardSurcharge: PropTypes.bool,
  showCxCardFields: PropTypes.bool.isRequired
}

export default PaymentChoices
